/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */

/**
 * Whether a participant has stipends and micropayments accepted for them.
 *
 * ``not_asked`` is the state every participant starts in and is what makes the
 * PWA offer the choice; it stays distinct from ``disabled`` so declining the
 * offer is never conflated with opting in.
 */
export type AutoAcceptPaymentsStatus =
  (typeof AutoAcceptPaymentsStatus)[keyof typeof AutoAcceptPaymentsStatus];

export const AutoAcceptPaymentsStatus = {
  not_asked: "not_asked",
  enabled: "enabled",
  disabled: "disabled",
} as const;
